
const digest = 'd9a189f53e9b2900b2d98e93ae54351037ccdc87458ff5d514e77713f47a226d';
const classes = {"wrapper":"_wrapper_yd574_1","inLine":"_inLine_yd574_8","radioWrapper":"_radioWrapper_yd574_12","radio":"_radio_yd574_12","active":"_active_yd574_29","title":"_title_yd574_34","errorMessage":"_errorMessage_yd574_39","wrapper2":"_wrapper2_yd574_45"};
const css = `._wrapper_yd574_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  gap: 10px;
}

._inLine_yd574_8 {
  flex-direction: row;
}

._radioWrapper_yd574_12 {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

._radio_yd574_12 {
  width: 25px;
  height: 25px;
  background: url("/dist/patientV3/icons/radio-default.svg") no-repeat center;
  background-size: contain;
  margin-right: 7.5px;
  cursor: pointer;
}

._active_yd574_29 {
  background: url("/dist/patientV3/icons/radio-selected.svg") no-repeat center;
  background-size: contain;
}

._title_yd574_34 {
  font-size: 14px;
  font-weight: 500;
}

._errorMessage_yd574_39 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}

._wrapper2_yd574_45 {
  display: block;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  